export default class IndirizziSpedizione{
    Cap;
    Citta;
    CodiceIndirizzo;
    Descrizione;
    Indirizzo;
    Provincia;
    K2AnagenIndir;
    constructor(){}
}